import { css } from '@emotion/react';
import {
  type FC, useCallback,
} from 'react';
import { useDispatch } from 'react-redux';
import { FloatingBoxWrapper } from '~/_shared/components/floatingBox/floatingBoxWrapper.component';
import { ToolInstructionsBoxComponent } from '~/_shared/components/toolInstructions/toolInstructionsBox.component';
import { clearActiveMapTemplate } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';
import {
  useActiveMapTemplateSelector, useFrontendStateLeftSidebarOpenedAppSelector,
  useFrontendStateLeftSidebarOpenedMapToolSelector,
} from '~/store/frontendState/leftSidebar/leftSidebar.selectors';
import { getTemplateToolOrApp } from './mapTemplates.helpers';
import { useMapTemplateInstructions } from './useMapTemplateInstructions.hook';

const MAP_EDGE_OFFSET = 20;
const MAP_LEFT_OFFSET = MAP_EDGE_OFFSET + 30; // extra clearance for zoom buttons

const floatingBoxWrapperStyle = css({
  cursor: 'default',
  left: MAP_LEFT_OFFSET,
  maxWidth: `calc(100% - ${MAP_LEFT_OFFSET}px - ${MAP_EDGE_OFFSET + 40}px)`, // 40px is for the map tools
  pointerEvents: 'none',
  top: MAP_EDGE_OFFSET,
  '& > *': {
    pointerEvents: 'auto',
  },
});

export const MapTemplateInstructionsContainer: FC = () => {
  const dispatch = useDispatch();
  const activeMapTemplate = useActiveMapTemplateSelector();
  const openedMapTool = useFrontendStateLeftSidebarOpenedMapToolSelector();
  const openedApp = useFrontendStateLeftSidebarOpenedAppSelector();
  const instructions = useMapTemplateInstructions();

  const closeInstructions = useCallback(() => {
    dispatch(clearActiveMapTemplate());
  }, [dispatch]);

  if (!activeMapTemplate) {
    return null;
  }

  const templateInstructions = instructions[activeMapTemplate];
  const toolOrApp = getTemplateToolOrApp(activeMapTemplate);

  if (!templateInstructions || !toolOrApp) {
    return null;
  }

  const isActive = toolOrApp.mapTool
    ? openedMapTool === toolOrApp.mapTool
    : openedApp === toolOrApp.sidebarApp;

  if (!isActive) {
    return null;
  }

  return (
    <FloatingBoxWrapper css={floatingBoxWrapperStyle}>
      <ToolInstructionsBoxComponent
        heading={templateInstructions.heading}
        onClose={closeInstructions}
        steps={templateInstructions.steps}
      />
    </FloatingBoxWrapper>
  );
};
